import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { locations } from 'services/routes/locations';
import useAnalytics from 'services/hooks/analytics';
import { events } from 'services/analytics';
import useUrlLocation from 'services/hooks/urlLocation';

interface FreeLimitReachedModalProps {
  open: boolean;
  onClose?: () => void;
}

const FreeLimitReachedModal = ({
  open,
  onClose,
}: FreeLimitReachedModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const location = useUrlLocation();

  const handleSubmit = useCallback(() => {
    track(events.upgradeSubscription('free_limit_reached_modal', location));
    navigate(locations.subscription.pricing.pathname(''));
  }, [navigate, track, location]);

  return (
    <ConversionDialog
      title={t('aiMusicGenerator:userLoop:freeUpgrade:title')}
      description={t('aiMusicGenerator:userLoop:freeUpgrade:description')}
      closeText={t('subscription:pricing:goBack')}
      submitText={t('general:action:upgrade')}
      state={{
        isOpen: open,
        isLoading: false,
        error: null,
      }}
      action={{
        onSubmit: handleSubmit,
        onClose,
      }}
    />
  );
};

export default FreeLimitReachedModal;
